<script>
  export default {
    name: 'public-layout'
  }
</script>

<template>
  <div>
    <router-view/>
  </div>
</template>

<style src="./PublicLayout.scss" lang="scss" scoped></style>
